import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './DashboardView.module.css';
import masaLogo from '../Assets/MasaLogo.png';

const DashboardView = () => {
  const navigate = useNavigate(); // Initialize the navigate function

  // Handlers for navigation with action context
  const handleAddClick = () => {
    navigate('/product-management', { state: { action: 'add' } }); // Pass "add" action context
  };

  const handleRemoveClick = () => {
    navigate('/product-management', { state: { action: 'remove' } }); // Pass "remove" action context
  };

  return (
    <main className={styles.dashboardView}>
      <header className={styles.header}>
        <img 
          loading="lazy" 
          src={masaLogo}
          className={styles.logo} 
          alt="Dashboard Logo" 
        />
        <h1 className={styles.dashboardTitle}>Workers Dashboard</h1>
      </header>
      <div className={styles.explanationText}>
        <p>
          Welcome to the <strong>product management dashboard</strong>. Press <strong>Add</strong> to add new products to the factory's inventory or <strong>Remove</strong> to reduce the product count from the inventory.
        </p>
      </div>
      <div className={styles.buttonContainer}>
        <button className={styles.addButton} onClick={handleAddClick}>
          <i className="fas fa-plus"></i> Add
        </button>
        <button className={styles.removeButton} onClick={handleRemoveClick}>
          <i className="fas fa-minus"></i> Remove
        </button>
      </div>
    </main>
  );
};

export default DashboardView;
